import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Book = createReactComponent("Book", ["svg", defaultAttributes, [["path", {
  d: "M4 19.5A2.5 2.5 0 016.5 17H20",
  key: "1bmfnz"
}], ["path", {
  d: "M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z",
  key: "1qo54g"
}]]]);
export default Book;